import React from "react";
import { CommonIconProps } from "./types";
import { IconBase } from "./IconBase"; // Import IconBase

export const IconJpg: React.FC<CommonIconProps> = (props) => {
  return (
    <IconBase
      iconStyle="solid"
      {...props}
      pathData={
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5 13.25C10.9142 13.25 11.25 13.5858 11.25 14V17.25C11.25 18.6307 10.1307 19.75 8.75 19.75H8.66667C7.33198 19.75 6.25 18.668 6.25 17.3333C6.25 16.9191 6.58579 16.5833 7 16.5833C7.41421 16.5833 7.75 16.9191 7.75 17.3333C7.75 17.8396 8.16041 18.25 8.66667 18.25H8.75C9.30228 18.25 9.75 17.8023 9.75 17.25V14C9.75 13.5858 10.0858 13.25 10.5 13.25ZM11.75 14C11.75 13.5858 12.0858 13.25 12.5 13.25H14C15.2426 13.25 16.25 14.2574 16.25 15.5C16.25 16.7426 15.2426 17.75 14 17.75H13.25V19C13.25 19.4142 12.9142 19.75 12.5 19.75C12.0858 19.75 11.75 19.4142 11.75 19V14ZM13.25 16.25H14C14.4142 16.25 14.75 15.9142 14.75 15.5C14.75 15.0858 14.4142 14.75 14 14.75H13.25V16.25ZM16.75 14C16.75 13.5858 17.0858 13.25 17.5 13.25H21C21.4142 13.25 21.75 13.5858 21.75 14V15C21.75 15.4142 21.4142 15.75 21 15.75C20.5858 15.75 20.25 15.4142 20.25 15V14.75H18.25V18.25H20.25V17.75H20C19.5858 17.75 19.25 17.4142 19.25 17C19.25 16.5858 19.5858 16.25 20 16.25H21C21.4142 16.25 21.75 16.5858 21.75 17V19C21.75 19.4142 21.4142 19.75 21 19.75H17.5C17.0858 19.75 16.75 19.4142 16.75 19V14Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.27427 19.823C2.27678 21.4403 3.58211 22.75 5.19144 22.75H16.8328C18.0256 22.75 19.0512 22.0306 19.5033 21H8.66667C6.64162 21 5 19.3584 5 17.3333C5 16.2288 5.89543 15.3333 7 15.3333C7.59735 15.3333 8.13353 15.5952 8.5 16.0104V14C8.5 12.8954 9.39543 12 10.5 12H19.75V9.05498C19.75 8.79546 19.6473 8.5466 19.4645 8.36329L12.6564 1.53551C12.4741 1.35268 12.2271 1.25 11.9695 1.25H5.16717C3.55429 1.25 2.24749 2.56532 2.25 4.18619L2.27427 19.823ZM11.5673 3.20594L17.8043 9.46094H13.0673C12.2389 9.46094 11.5673 8.78936 11.5673 7.96094V3.20594Z"
            fill="currentColor"
          />
        </>
      }
    />
  );
};
